/**
 * Clean up Intercom session on logout to prevent cross-user contamination
 */
export const shutdownIntercom = () => {
  try {
    if (
      typeof window !== 'undefined' &&
      window.Intercom &&
      typeof window.Intercom === 'function'
    ) {
      window.Intercom('shutdown');
    }
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.warn('Failed to shutdown Intercom:', error);
  }
};
